export const GRAPHQL_API_URL = "https://cmd.wx1.eu/api/graphql"